import React, { useState, useEffect } from 'react'
import { Bar } from 'react-chartjs-2'


const OffsetChart = (props) => {

  const { usage, production, currentUsage } = props

  const [displayUsage, setDisplayUsage] = useState('')

  useEffect(() => {
    setDisplayUsage(usage)
    // eslint-disable-next-line
  }, [props])


  useEffect(() => {
    if (props.uType === 'Square Footage') {
      return setDisplayUsage([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])
    }
  }, [props])

  const blue = '#0c9ebf'
  const gray = 'rgba(255, 255, 255, 1)'


  return (
    <div>
      <Bar
        data={{
          labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
          datasets: [
            {
              
              label: "Production",
              datalabels: {
                display: false
              },
              type: "line",
              borderColor: "rgb(250, 212, 23)",
              data: [
                production[0].toFixed(0),
                production[1].toFixed(0),
                production[2].toFixed(0),
                production[3].toFixed(0),
                production[4].toFixed(0),
                production[5].toFixed(0),
                production[6].toFixed(0),
                production[7].toFixed(0),
                production[8].toFixed(0),
                production[9].toFixed(0),
                production[10].toFixed(0),
                production[11].toFixed(0)
              ],
              fill: true,
              backgroundColor: "rgb(250, 212, 23, .2)", 
              // pointStyle: [...Array(11).fill('circle'), 'triangle'],
              // pointRadius: [...Array(11).fill(3), 7],
              // pointRotation: [...Array(11).fill(0), 53],
            }, {
              barThickness: 30,
              label: "Usage",
              datalabels: {
                display: false
              },
              type: "bar",
              backgroundColor: [
                props.uType === 'Partial 12 Months' ? (currentUsage[0] > 0 ? blue : gray) : (blue),
                props.uType === 'Partial 12 Months' ? (currentUsage[1] > 0 ? blue : gray) : (blue),
                props.uType === 'Partial 12 Months' ? (currentUsage[2] > 0 ? blue : gray) : (blue),
                props.uType === 'Partial 12 Months' ? (currentUsage[3] > 0 ? blue : gray) : (blue),
                props.uType === 'Partial 12 Months' ? (currentUsage[4] > 0 ? blue : gray) : (blue),
                props.uType === 'Partial 12 Months' ? (currentUsage[5] > 0 ? blue : gray) : (blue),
                props.uType === 'Partial 12 Months' ? (currentUsage[6] > 0 ? blue : gray) : (blue),
                props.uType === 'Partial 12 Months' ? (currentUsage[7] > 0 ? blue : gray) : (blue),
                props.uType === 'Partial 12 Months' ? (currentUsage[8] > 0 ? blue : gray) : (blue),
                props.uType === 'Partial 12 Months' ? (currentUsage[9] > 0 ? blue : gray) : (blue),
                props.uType === 'Partial 12 Months' ? (currentUsage[10] > 0 ? blue : gray) : (blue),
                props.uType === 'Partial 12 Months' ? (currentUsage[11] > 0 ? blue : gray) : (blue),
              ],
              data: [
                Math.round(displayUsage[0]),
                Math.round(displayUsage[1]),
                Math.round(displayUsage[2]),
                Math.round(displayUsage[3]),
                Math.round(displayUsage[4]),
                Math.round(displayUsage[5]),
                Math.round(displayUsage[6]),
                Math.round(displayUsage[7]),
                Math.round(displayUsage[8]),
                Math.round(displayUsage[9]),
                Math.round(displayUsage[10]),
                Math.round(displayUsage[11])
              ],
            }
          ]
        }
        }
        options={{
          title: {
            display: true,
            text: '',
            fontSize: 25,
            fontColor: '#000'
          },
          legend: {
            display: false,
            position: 'bottom',
            labels: { fontColor: '#000' }
          }, scales: {
            xAxes: [{

              ticks: {
                display: false
              },
              gridLines: {
                color: "rgba(0, 0, 0, 0)",
              }
            }],
            yAxes: [{
              ticks: {
                beginAtZero: true,
                fontColor: '#fff',
              },
              gridLines: {
                color: "rgba(0, 0, 0, 0)",
              }
            }]
          }
        }} height={120} />
    </div>
  )

}

export default OffsetChart
